/** SPEC §17.2: kiezen of wisselen tussen organisaties waarin je gebruiker bent. */
import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { ROL_LABEL, type Rol } from '@ep/core';
import { api } from '../lib/api';
import { Icoon } from './Icoon';
import { toast } from './toast';
import { Laden, Modal } from './ui';

interface Org {
  id: string;
  naam: string;
  slug: string;
  rol: Rol;
  kleur: string | null;
}

export function OrganisatieKiezer({ naInloggen, onSluit }: { naInloggen?: boolean; onSluit: () => void }) {
  const q = useQuery({ queryKey: ['mijn-organisaties'], queryFn: () => api.get<{ huidig: string; organisaties: Org[] }>('/api/mijn-organisaties') });
  const [bezig, setBezig] = useState<string | null>(null);
  const kies = async (o: Org) => {
    setBezig(o.id);
    try {
      const r = await api.post<{ gewisseld: boolean }>('/api/wissel-organisatie', { tenantId: o.id });
      // nieuwe organisatie: app opnieuw laden zodat er geen gegevens van de vorige blijven staan
      if (r.gewisseld) window.location.href = '/';
      else onSluit();
    } catch (e) {
      toast((e as Error).message, 'fout');
      setBezig(null);
    }
  };
  return (
    <Modal titel={naInloggen ? 'Kies een organisatie' : 'Wissel organisatie'} onSluit={onSluit}>
      <p className="klein mute" style={{ marginTop: 0 }}>
        {naInloggen ? 'Je hebt toegang tot meerdere organisaties. Waar wil je werken? Je keuze wordt onthouden; wisselen kan later via je gebruikersmenu.' : 'Je gegevens en rol zijn per organisatie apart. Na het wisselen wordt de app opnieuw geladen.'}
      </p>
      {!q.data ? <Laden /> : (
        <div className="org-lijst">
          {q.data.organisaties.map((o) => {
            const huidig = o.id === q.data!.huidig;
            return (
              <button key={o.id} className={`org-keuze${huidig ? ' huidig' : ''}`} disabled={!!bezig} onClick={() => kies(o)}>
                <span className="org-kleur" style={{ background: o.kleur ?? 'var(--merk)' }}>{o.naam.trim().charAt(0).toUpperCase()}</span>
                <span className="groei">
                  <span className="vet">{o.naam}</span>
                  <span className="klein mute">{ROL_LABEL[o.rol] ?? o.rol}{huidig ? ' · huidige organisatie' : ''}</span>
                </span>
                {bezig === o.id ? <span className="klein mute">bezig…</span> : huidig ? <Icoon naam="check" maat={18} /> : <Icoon naam="chevron-right" maat={18} />}
              </button>
            );
          })}
          {!q.data.organisaties.length && <div className="leeg">Log opnieuw in om van organisatie te kunnen wisselen.</div>}
        </div>
      )}
    </Modal>
  );
}
